export default __webpack_public_path__ + "static/media/about-team-03.05b43791.jpg";